import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      gap: 3,
    },

    dot: {
      width: 5,
      height: 5,
      borderRadius: '50%',
      backgroundColor: COLORS.primary.default,
      animation: '$bounce 0.7s infinite alternate',

      '&:nth-child(2)': {
        animationDelay: '0.15s',
      },
      '&:nth-child(3)': {
        animationDelay: '0.25s',
      },
    },

    '@keyframes bounce': {
      '0%': {
        opacity: 1,
        transform: 'translateY(0px)',
      },

      //this is a hack to make the dots pause for half of the time
      '50%': {
        opacity: 0.5,
        transform: 'translateY(-4px)',
      },

      '100%': {
        opacity: 0.5,
        transform: 'translateY(-4px)',
      },
    },
  }),
  { name: 'BouncingDots' }
);
